import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { TravelStatus } from 'models/travelStatus';

import { Tag } from './styles';

export enum TravelPolicies {
  OutOfPolicies = 'OutOfPolicies',
  WithInPolicies = 'WithInPolicies',
}

const TravelTag = ({ status }: { status: TravelStatus | TravelPolicies | string }): JSX.Element => {
  const { t } = useStoreTranslation();
  if (status === String(TravelStatus.ExchangePending))
    return (
      <Tag.Pending>
        <Tag.PendingIcon />
        Cambio pendiente
      </Tag.Pending>
    );
  if (status === String(TravelPolicies.OutOfPolicies))
    return (
      <Tag.OutOfPolicies>
        <Tag.OutOfPoliciesIcon />
        {t('flightDetails.outOfPolicies')}
      </Tag.OutOfPolicies>
    );
  if (status === String(TravelPolicies.WithInPolicies))
    return (
      <Tag.Confirmed>
        <Tag.ConfirmedIcon />
        {t('flightDetails.withinPolicies')}
      </Tag.Confirmed>
    );
  if (status === String(TravelStatus.Confirmed))
    return (
      <Tag.Confirmed>
        <Tag.ConfirmedIcon />
        {t(`tripCard.status.${status}`)}
      </Tag.Confirmed>
    );
  if (status === String(TravelStatus.Pending))
    return (
      <Tag.Pending>
        <Tag.PendingIcon />
        {t(`tripCard.status.${status}`)}
      </Tag.Pending>
    );
  if (status === String(TravelStatus.Approved) || status === String(TravelStatus.PreApproved))
    return (
      <Tag.Processing>
        <Tag.ProcessingIcon src="/corporate/images/clock-check-icon.png" />
        {t(`tripCard.status.${status}`)}
      </Tag.Processing>
    );
  if (status === String(TravelStatus.Paid))
    return (
      <Tag.Paid>
        <Tag.PaidIcon />
        {t(`tripCard.status.${status}`)}
      </Tag.Paid>
    );
  return (
    <Tag.Error>
      <Tag.ErrorIcon />
      {t(`tripCard.status.${status}`)}
    </Tag.Error>
  );
};

export default TravelTag;
